import React, {useContext} from 'react';
import { Button } from '../Button';
import { HeadContext } from '../../Provider';
import { iObra } from '../../Services/ObraServices';
import './index.scss';

interface iProps {
    model: iObra
    handleClickInfo: any
}

export default (props: iProps) => {

    const context = useContext(HeadContext);

    return (
        <div className="c_work">
            <img className="c_work__image" src={`https://test.archi.pe/cdn/thumbs/obra/${props.model.imagen}`} />
            <p className="c_work__title e-p1 e-p2:md e-p4:lg e-p5:xl">{props.model.titular}</p>
            <div className="c_work__detail">
                <p className="c_work__date e-p2 e-p3:md e-p4:lg e-p5:xl">{props.model.fecha_epoca}</p>
                <p className="c_work__author e-p2 e-p3:md e-p4:lg e-p5:xl">{props.model.autor_id}</p>
            </div>
            <p className="c_work__description e-p2 e-p4:md e-p5:lg">{props.model.notas_forma}</p>
            <Button className="c_work__button" link={`/obra/${props.model.id}`} theme="black" prelink={()=>{ context.setShowSearch(false) }}>MÁS INFORMACION</Button>
        </div>
    )
}